<script>
  import { scaleLinear, scaleBand } from "d3-scale";
  import { min, max } from "d3-array";
  import { format } from "d3-format";
  export let barData;
  export let chartTitle;
  export let referenceCountries;
  export let primaryCountry;
  import { colors } from "./../colors";

  const margin = { top: 40, bottom: 20, left: 160, right: 50 };
  const width = 800;
  $: height = barData.length > 0 ? barData.length * 50 + 40 : 100;
  $: innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;
  const fill = "#cccccc";

  let xScale;
  let yScale;
  $: if (barData.length > 0) {
    xScale = scaleLinear()
      .domain([
        min(barData, (d) => d.x) >= 0 ? 0 : min(barData, (d) => d.x),
        max(barData, (d) => d.x),
      ])
      .range([0, innerWidth]);
  }
  $: if (barData.length > 0) {
    yScale = scaleBand()
      .domain(barData.map((d) => d.label))
      .range([innerHeight, 0])
      .paddingInner(0.3);
  }
</script>

<svg {width} {height} class="chart">
  <g transform={`translate(${margin.left},${margin.top})`}>
    <text x={barData.length === 0 ? -margin.left : 0} y={-20} font-size={24}
      >
      {barData.length === 0
        ? "Select a primary or reference countries to generate a bar chart"
        : chartTitle}</text
    >
    {#if barData.length === 0 && referenceCountries !== null && referenceCountries.length > 0}
      <rect
        x={0}
        y={0}
        width={innerWidth}
        height={innerHeight}
        fill={"#ffe2d9"}
      />
      <text
        x={innerWidth / 2}
        y={innerHeight / 3}
        text-anchor={"middle"}
        fill={"#a3320f"}
        >No data available for this combination of year and indicator</text
      >
      <text
        x={innerWidth / 2}
        y={innerHeight / 3 + 20}
        text-anchor={"middle"}
        fill={"#a3320f"}
        >Select another year or indicator, or check "Show most recent year available"</text
      >
    {/if}

    {#each barData as bar}
      <text
        x={bar.x >= 0 ? xScale(0) - 4 : xScale(0) + 4}
        y={yScale(bar.label) + 6 + yScale.bandwidth() / 2}
        text-anchor={bar.x >= 0 ? "end" : "start"}>{bar.label}</text
      >
      <rect
        x={bar.x >= 0 ? xScale(0) : xScale(bar.x)}
        y={yScale(bar.label)}
        width={bar.x >= 0
          ? xScale(bar.x) - xScale(0)
          : xScale(0) - xScale(bar.x)}
        height={yScale.bandwidth()}
        fill={primaryCountry && bar.label === primaryCountry.label
          ? colors.primary
          : colors.reference}
        stroke-width={0}
      />
      <text
        x={bar.x >= 0 ? xScale(bar.x) + 4 : xScale(bar.x) - 4}
        height={yScale.bandwidth() + 6}
        y={yScale(bar.label) + 6 + yScale.bandwidth() / 2}
        text-anchor={bar.x >= 0 ? "start" : "end"}>{format(",.1f")(bar.x)}</text
      >
    {/each}
  </g>
</svg>
